import { dashboardApi } from '../store/services/dashboard'
import { authApi } from "../store/services/auth"
import { utilityApi } from "../store/services/utility";
import { schoolsApi } from "../store/services/schools";
import { schoolDivisonsApi } from "../store/services/schoolsDivisons";
import { schoolClientsApi } from "../store/services/clients/school.client";
import { clientCaseLoadsApi } from "../store/services/clientCaseLoads";
import { assessmentTreatmentPlanApi } from "../store/services/clients/assessmentTreatmentPlan";
import { ssoApi } from "../store/services/sso";
import { cmsApi } from "../store/services/cms";
import { chatterClientsApi } from "../store/services/clients/chatter";
import { homeEducationApi } from "../store/services/clients/homeEducation";
import { noteApi } from "../store/services/note";
import { attendanceApi } from "../store/services/clients/attendance";
import { privateClientApi } from "../store/services/clients/private";
import { mdtAssessmentApi } from "../store/services/mdt/assessment";
import { resourceApi } from "../store/services/resource";
import { groupApi } from "../store/services/group";
import { dischargeApi } from "../store/services/discharge";
import { chatterProgramApi } from "../store/services/chatterPrograms";
import { lessonApi } from "../store/services/lesson";
import { ClassroomConsultationApi } from "../store/services/classroom";
import { staffApi } from "../store/services/staff";
import { chatApi } from "../store/services/chat";
import { apprenticeApi } from "../store/services/clients/apprentice";
import { attachmentApi } from "../store/services/clients/attachment";
import { teamApi } from "../store/services/team";
import { appointmentApi } from "../store/services/appointment";
import { baseApi } from "utils/axios/baseApi";
import { consentFormApi } from 'store/services/consent';
import { schoolReportsApi } from 'store/services/clients/reports-v2/schoolReports';
import { assessmentTreatmentGoalsApi } from "store/services/clients/reports-v2/goals";
import { recommendationTemplatesApi } from "store/services/clients/reports-v2/recommendationTemplates";
import { classroomReportApi } from "store/services/clients/reports-v2/classroomReport";
import { chatterReportsApi } from 'store/services/clients/reports-v2/chatterReports';
import { myProfileApi } from 'store/services/V2/profile';
import { clientReportApi } from 'store/services/report';
import { supportStaffApi } from 'store/services/V2/supportStaff'; 
import { taskPlanTemplateApiV2 } from 'store/services/V2/TaskPlanTemplate';
import { taskPlanApiV2 } from 'store/services/V2/TaskPlan';
import { mdtCaseloadsApi } from 'store/services/mdtCaseload';
import { notificationsApi } from 'store/services/notifications';
import { policiesApi } from 'store/services/policies';

export default [
  baseApi,
  dashboardApi,
  authApi,
  utilityApi,
  schoolsApi,
  myProfileApi,
  clientReportApi,
  schoolDivisonsApi,
  schoolClientsApi,
  clientCaseLoadsApi,
  assessmentTreatmentPlanApi,
  ssoApi,
  cmsApi,
  chatterClientsApi,
  homeEducationApi,
  noteApi,
  attendanceApi,
  privateClientApi,
  mdtAssessmentApi,
  mdtCaseloadsApi,
  resourceApi,
  groupApi,
  dischargeApi,
  chatterProgramApi,
  lessonApi,
  ClassroomConsultationApi,
  staffApi,
  chatApi,
  apprenticeApi,
  attachmentApi,
  teamApi,
  appointmentApi,
  baseApi,
  consentFormApi,
  schoolReportsApi,
  assessmentTreatmentGoalsApi,
  recommendationTemplatesApi,
  classroomReportApi,
  chatterReportsApi,
  supportStaffApi,
  taskPlanTemplateApiV2,
  taskPlanApiV2,
  notificationsApi,
  policiesApi
]